import script from "./LotesView.vue?vue&type=script&setup=true&lang=js"
export * from "./LotesView.vue?vue&type=script&setup=true&lang=js"

import "./LotesView.vue?vue&type=style&index=0&id=6e444cfe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e444cfe"]])

export default __exports__